import { Link } from "react-router-dom";
import { useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      toast.success("Merci ! Vous êtes inscrit(e) à la newsletter.");
      setEmail("");
    } catch (err) {
      toast.error("Une erreur est survenue.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="mt-32 border-t border-border bg-secondary/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-serif text-2xl tracking-tight">BARON <span className="text-accent">BOOKS</span></div>
          <p className="mt-4 text-sm text-muted-foreground leading-relaxed max-w-md italic">
            « Des histoires qui éveillent, inspirent et transforment. »
          </p>
          <p className="mt-2 text-sm text-muted-foreground leading-relaxed max-w-md">
            La librairie indépendante de Baron Vincent de Paul. Livres numériques livrés directement dans votre bibliothèque.
          </p>
          <form onSubmit={subscribe} className="mt-6 flex gap-2 max-w-md">
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="votre@email.com"
              data-testid="newsletter-input"
              className="rounded-sm bg-transparent"
            />
            <Button data-testid="newsletter-submit" type="submit" disabled={loading} className="rounded-sm">
              {loading ? "..." : "S'abonner"}
            </Button>
          </form>
        </div>
        <div>
          <div className="label-eyebrow text-muted-foreground mb-4">Navigation</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/catalogue" className="hover:text-accent">Livres</Link></li>
            <li><Link to="/auteur" className="hover:text-accent">À propos</Link></li>
            <li><Link to="/faq" className="hover:text-accent">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-accent">Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow text-muted-foreground mb-4">Aide</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/faq" className="hover:text-accent">Livraison</Link></li>
            <li><Link to="/faq" className="hover:text-accent">Remboursement</Link></li>
            <li><Link to="/faq" className="hover:text-accent">Conditions générales</Link></li>
            <li><Link to="/faq" className="hover:text-accent">Confidentialité</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between items-center text-xs text-muted-foreground">
          <div>© {new Date().getFullYear()} BARON BOOKS — Baron Vincent de Paul. Tous droits réservés.</div>
          <div className="flex gap-6 mt-2 md:mt-0">
            <a href="#" className="hover:text-accent">Mentions légales</a>
            <a href="#" className="hover:text-accent">CGV</a>
            <a href="#" className="hover:text-accent">Confidentialité</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
